import React from "react";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
// material-ui icons
import Snackbar from "components/Snackbar/Snackbar.jsx";
import ModalPregunta from "components/Generales/ModalPregunta";
import ModalEditarUsuariosWeb from "views/Modulos/AtencionUsuarios/UsuariosWeb/ModalEditarUsuariosWeb.jsx";
import Globales from "utils/Globales";
import { Edit, Close, AddCircle, Search, Clear, Filter9Plus } from "@material-ui/icons";

class usuario extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: '',
      Usuario: '',
      Contrasena: '',
      ConfirmacionContrasena: '',
      NombreUsuario: '',
      Correo: '',
      Telefono: '',
      TipoUsuario: '',
      Titulo: '',
      usuarios: [],
      mensaje: '',
      br: false,
      colorNotificacion: 'success',
      errorUsuario: false,
      errorContrasena: false,
      errorConfirmacionContrasena: false,
      errorCorreo: false,
      errorNombreUsuario: false,
      errorTelefono: false,
      errorTipoUsuario: false,
      usuariosMostrar: [],
      entroFiltrar: false,
      notificacion: false
    };
    //Variable global para indicar el total de registros que se obtendra de la base de datos
    global.Fin = 5;
    global.entrar = true;
    this.eventoModalEliminar = this.eventoModalEliminar.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.eliminarUsuario = this.eliminarUsuario.bind(this);
    // this.filtrarUsuario = this.filtrarUsuario.bind(this);
    this.seleccionado = {};
  }

  componentDidMount() {
    this.obtenerUsuariosWeb();
    this.obtenerAllUsuarios();
  }

  //Obtener todos los registros guardados
  obtenerAllUsuarios() {
    fetch(Globales.Url + 'UsuarioClientes/UsuarioClientes/AllUsuariosWeb', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({ Fin: 0 })
    })
      .then(res => res.json())
      .then(data => {
        if (data.error) { //Error al obtener los registros
          this.setState({ usuarios: [] });
        } else { //Obtuvo los registros correctamente
          this.setState({ usuarios: data.data });

        }
      });
  }

  //Funcion para Filtrar Usuario
  filtrarUsuario(){
    var valor1 = 0;
    //Validar que el input no este vacio
    if (this.state.Usuario.trim() == '') {
      this.setState({ errorUsuario: true, colorNotificacion: 'danger', mensaje: "Complete el campo de búsqueda", Usuario: '' });
      valor1 = 1;
    } else {
      this.setState({ errorNombre: false });
      valor1 = 0;
    }
    //Validar si hay campos requeridos
    if (valor1 > 0) { //Hay campos requeridos
      this.showNotification();
    } else { //No hay campos requeridos
      fetch(Globales.Url + 'UsuarioClientes/UsuarioClientes/FiltrarAllUsuarioWeb', {
        method: 'POST',
        headers: {
          Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
        }
        , body: JSON.stringify({UsuarioWeb:this.state.Usuario})
      }
      ).then(res => res.json())
        .then(data => {
          if (data.error) { //Error en la respuesta
            this.setState({ colorNotificacion: 'danger', mensaje: data.mensaje });
            this.showNotification();
          } else if (data.mensaje.length == 0) { //Ninguna coincidencia
            this.setState({ colorNotificacion: "warning",usuariosMostrar:[], mensaje: "No hay ninguna coincidencia", entroFiltrar: true })
            this.showNotification();
          } else { //Filtrado exitoso
            this.setState({ colorNotificacion: 'success', usuariosMostrar: data.mensaje, entroFiltrar: true })
          }
        })
        .catch(err => console.error(err));
    }
  }

  //Obtener el total de registros que se indican
  obtenerUsuariosWeb() {
    fetch(Globales.Url + 'UsuarioClientes/UsuarioClientes/AllUsuariosWeb', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({ Fin: global.Fin })
    }
    ).then(res => res.json())
      .then(data => {
        if (data.error) { //Error al obtener los registros
          this.setState({ colorNotificacion: 'danger', mensaje: data.mensaje });
          this.showNotification();
        } else { //Obtuvo los registros correctamente
          this.setState({ usuariosMostrar: data.data });
        }
      })
      .catch(err => console.error(err));
  }

  //Función de editar registro
  editarUsuario(usuario) {
    this.setState({ _id: usuario._id,
        Usuario: usuario.Usuario,
        Contrasena: usuario.Contrasena,
        NombreUsuario: usuario.Nombre, 
        Correo: usuario.Correo, 
        Telefono: usuario.Telefono,
        TipoUsuario: usuario.TipoUsuario, 
        op: 1,
        showAgregar: true,
        Titulo: "Editar Usuario Web" });
  }

  //Función de eliminar registro
  eliminarUsuario(id) {
    fetch(Globales.Url + 'UsuarioClientes/UsuarioClientes/BajaUsuarioWeb', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({ _id: id })
    }
    ).then(res => res.json())
      .then(data => {
        if (data.error) {//Error al obtener los registros
          this.setState({ colorNotificacion: 'danger' });
        } else {//Obtuvo los registros correctamente
          this.setState({ colorNotificacion: 'success' });
        }
        this.setState({ mensaje: data.mensaje, show: false });
        this.showNotification();
        // this.obtenerUsuariosWeb();
        this.limpiar();
      });
  }

  //Función para el evento de eliminar
  deleteEvent = (values) => {
    this.seleccionado = values;
    this.setState({ show: true });
  }

  //Función para habilitar el modal de eliminar
  eventoModalEliminar(e) {
    if (!e) {
      this.setState({ show: false });
      return;
    }
    //Eliminar el elemento
    this.eliminarUsuario(this.seleccionado);
  }

  //Función que recupera valores para el modal de agregar
  eventoModalUsuario = (mensaje, colorNotificacion) => {
    //Cambiar valores por default
    this.setState({ showAgregar: false, Titulo: "Nuevo Usuario", Usuario: "", Contrasena: "", op: 0 })
    this.obtenerUsuariosWeb();
    this.limpiar();
    //Validar que el mensaje venga diferente de vacio
    if (mensaje !== 'esc') {
      this.setState({ mensaje: mensaje, colorNotificacion: colorNotificacion })
      this.showNotification();
    }
  }

  //Función que habilita la notificación
  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function () {
        this.setState({ br: false, notificacion: false });
        this.setState(x);
      }.bind(this),
      4000
    );
  }

  //Función para obtener el texto de los inputs
  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  //Función para volver los valores por default
  limpiar() {
    this.setState({ Usuario: '', entroFiltrar: false });
    global.Fin = 5;
    global.entrar = true;
    this.obtenerUsuariosWeb();
    this.obtenerAllUsuarios();
  }

  //Función para mostrar mas registros en la tabla
  verMas() {
    //Validar si entro a filtrar
    if (this.state.entroFiltrar) {
      this.limpiar();
    } else {
      //Creando variable con mas valor que la variable global
      var num = global.Fin + 5;
      var mostrarMensaje = false;
      if(this.state.usuarios.length <= global.Fin){
        mostrarMensaje = true;
      }
      //Validación de el valor de la variable global sea menor o igual que el total de registros obtenidos
      if (num <= this.state.usuarios.length && global.entrar) {
        //Cambiando el valor de la variable global
        global.Fin = num;
        //Obteniendo el número de registros requeridos
        this.obtenerUsuariosWeb();
      };
      //Validación de que el número total de registros requiridos sea mayor al total de registros y cambio de valor de variables
      if (num > this.state.usuarios.length && global.entrar) {
        //Cambiando el valor de la variable para que no vuelva a traer mas registros
        global.entrar = false;
        //Cambiando el valor de la variable global
        global.Fin = this.state.usuarios.length;
        //Obteniendo el total de los registros requeridos
        this.obtenerUsuariosWeb();
      };
      //Validación de que ya no hay mas registros que mostrar
      if (mostrarMensaje) {
        this.setState({ mensaje: 'No hay más usuarios para mostrar', colorNotificacion: 'warning' });
        this.showNotification();
      };
    }
  }

  //Obtener el nombre de la categoría de objetpo
  obtenerNombreCategoria(Contrasena) {
    var nombre = '';
    this.state.usuarios.map(cat => {
      if (Contrasena === cat._id) {
        nombre = cat.NombreCategoria
      }
    });
    return nombre;
  }

  render() {
    let agregar;
    if (this.state.showAgregar == true) {
      agregar =
        <ModalEditarUsuariosWeb
          Titulo={this.state.Titulo}
          Usuario={this.state.Usuario}
          Contrasena={this.state.Contrasena}
          ConfirmacionContrasena={this.state.ConfirmacionContrasena}
          NombreUsuario={this.state.NombreUsuario}
          Correo={this.state.Correo}
          Telefono={this.state.Telefono}
          TipoUsuario={this.state.TipoUsuario}
          usuarios={this.state.usuarios}
          _id={this.state._id}
          showAgregar={this.state.showAgregar}
          eventClick={this.eventoModalUsuario}
          op={this.state.op}
        />
    }
    const { classes } = this.props;
    return (
      <div>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info" text>
                <h4 className={classes.cardTitle}>Usuarios Web</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Buscar usuario"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        required: true,
                        onChange: this.handleChange,
                        value: this.state.Usuario,
                        name: "Usuario",
                        id: "Usuario",
                        type: "text",
                        error: this.state.errorUsuario
                      }}
                      className="mt-5"
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                     <Button size="sm" type="submit" className="pull-left mt-5" color="info" round onClick={() => this.filtrarUsuario()}><Search />Buscar</Button>
                    <Button size="sm" type="submit" className="pull-left mt-5" color="danger" round onClick={() => this.limpiar()}><Clear />Limpiar</Button>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                    <Button size="sm" type="submit" className="pull-right mt-5" color="info" round onClick={() => this.verMas()}><Filter9Plus />Ver Más</Button>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer justify="center">
          {/* Tabla de tiposUsuarios */}
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info">
                <GridContainer>
                  <GridItem xs={12} sm={12} md={7}>
                    <h4 className="pull-left">Lista de Usuarios</h4>
                  </GridItem>
                </GridContainer>
              </CardHeader>
              <CardBody>
                <div className="table-wrapper-scroll-y">
                  <table className="col-xs-12 col-sm-12 col-md-12">
                    <thead>
                      {/* <th className="center">Usuario</th> */}
                      <th className="center">Nombre</th>
                      <th className="center">Correo</th>
                      <th className="center">Telefono</th>
                      <th className="center">Tipo</th>
                      <th className="pull-right">Acciones</th>
                    </thead>
                    <tbody>
                      {this.state.usuariosMostrar.map(usuario => {
                        return (
                          <tr key={usuario._id}>
                            {/* <td>{usuario.Usuario}</td> */}
                            <td>{usuario.Nombre}</td>
                            <td>{usuario.Correo}</td>
                            <td>{usuario.Telefono}</td>
                            <td>{usuario.TipoUsuario}</td>
                            <td className="pull-right">
                              <Button color="warning" round justIcon size="sm" onClick={() => this.editarUsuario(usuario)}><Edit /></Button>
                              <Button color="danger" round justIcon size="sm" onClick={() => this.deleteEvent(usuario._id)}><Close /></Button>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <div id="">
          <ModalPregunta
            Titulo={"Eliminar Usuario"}
            Cuerpo={"¿Está seguro que desea eliminar el usuario?"}
            show={this.state.show}
            eventClick={this.eventoModalEliminar}
          />
          {agregar}
        </div>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
      </div>
    )
  }
}

export default withStyles(headerLinksStyle)(usuario);